// Import all Framework7-Vue components used in the app
import {
  f7,
  f7Actions,
  f7ActionsButton,
  f7ActionsGroup,
  f7ActionsLabel,
  f7App,
  f7Badge,
  f7Block,
  f7BlockHeader,
  f7BlockTitle,
  f7Button,
  f7Card,
  f7CardContent,
  f7CardFooter,
  f7CardHeader,
  f7Checkbox,
  f7Chip,
  f7Fab,
  f7FabButton,
  f7FabButtons,
  f7Icon,
  f7Input,
  f7Link,
  f7List,
  f7ListButton,
  f7ListInput,
  f7ListItem,
  f7LoginScreen,
  f7Navbar,
  f7NavLeft,
  f7NavRight,
  f7NavTitle,
  f7Page,
  f7PageContent,
  f7Panel,
  f7PhotoBrowser,
  f7Popover,
  f7Popup,
  f7Preloader,
  f7Progressbar,
  f7Radio,
  f7Range,
  f7ready,
  f7Searchbar,
  f7Segmented,
  f7Sheet,
  f7SkeletonBlock,
  f7Stepper,
  f7Subnavbar,
  f7SwipeoutActions,
  f7SwipeoutButton,
  f7Tab,
  f7Tabs,
  f7Toggle,
  f7Toolbar,
  f7View,
  f7Views,
} from 'framework7-vue';

// Export register function
export function registerComponents(app) {
  // Register Framework7-Vue components
  app.component('F7App', f7App);
  app.component('F7View', f7View);
  app.component('F7Page', f7Page);
  app.component('F7Navbar', f7Navbar);
  app.component('F7Toolbar', f7Toolbar);
  app.component('F7Link', f7Link);
  app.component('F7Block', f7Block);
  app.component('F7BlockHeader', f7BlockHeader);
  app.component('F7BlockTitle', f7BlockTitle);
  app.component('F7List', f7List);
  app.component('F7ListItem', f7ListItem);
  app.component('F7Button', f7Button);
  app.component('F7Tabs', f7Tabs);
  app.component('F7Tab', f7Tab);
  app.component('F7Badge', f7Badge);
  app.component('F7Icon', f7Icon);
  app.component('F7Popup', f7Popup);
  // Swipeout functionality is now part of f7-list-item in Framework7 v8
  // The swipeout-actions and swipeout-button are now rendered as child elements
  app.component('F7Panel', f7Panel);
  app.component('F7Toggle', f7Toggle);
  app.component('F7Card', f7Card);
  app.component('F7CardHeader', f7CardHeader);
  app.component('F7CardContent', f7CardContent);
  app.component('F7CardFooter', f7CardFooter);
  app.component('F7Input', f7Input);
  app.component('F7Radio', f7Radio);
  app.component('F7Preloader', f7Preloader);
  app.component('F7ListInput', f7ListInput);
  app.component('F7NavRight', f7NavRight);
  app.component('F7NavLeft', f7NavLeft);
  app.component('F7NavTitle', f7NavTitle);
  app.component('F7PageContent', f7PageContent);
  app.component('F7Segmented', f7Segmented);
  app.component('F7Progressbar', f7Progressbar);
  app.component('F7LoginScreen', f7LoginScreen);
  app.component('F7Popover', f7Popover);
  app.component('F7Searchbar', f7Searchbar);
  app.component('F7Chip', f7Chip);
  app.component('F7Sheet', f7Sheet);
  app.component('F7Views', f7Views);
  app.component('F7Checkbox', f7Checkbox);
  app.component('F7Range', f7Range);
  app.component('F7PhotoBrowser', f7PhotoBrowser);
  app.component('F7SkeletonBlock', f7SkeletonBlock);
  app.component('F7Subnavbar', f7Subnavbar);
  app.component('F7Actions', f7Actions);
  app.component('F7ActionsGroup', f7ActionsGroup);
  app.component('F7ActionsButton', f7ActionsButton);
  app.component('F7ActionsLabel', f7ActionsLabel);
  app.component('F7Fab', f7Fab);
  app.component('F7FabButtons', f7FabButtons);
  app.component('F7FabButton', f7FabButton);
  app.component('F7SwipeoutActions', f7SwipeoutActions);
  app.component('F7SwipeoutButton', f7SwipeoutButton);
  app.component('F7ListButton', f7ListButton);
  app.component('F7Stepper', f7Stepper);


}

// Export other Framework7 utilities for direct import in components
export { f7, f7ready };
